import { LikeObserver } from '@widgets/like-product';

import { LikeButton } from '../components/LikeButton';
import { ReviewButton } from '../components/ReviewButton';
import { useSubButtonLog } from '../log/useSubButtonLog';
import { useSubButtonService } from '../services/useSubButtonService';

export function SubButtonContainer({ product_id, shop_id }: { product_id: string; shop_id: string }) {
  const { is_visible, ...service } = useSubButtonService({ product_id, shop_id });
  const log = useSubButtonLog();

  return (
    <>
      <ReviewButton
        has_review_event={service.has_review_event}
        total_count={service.review_total_count}
        onClick={() => {
          log.reviewClickUBL();
          service.goToReviewList();
        }}
      />
      {is_visible && (
        <LikeObserver catalogProductId={product_id}>
          {({ isLiked, ref }) => (
            <LikeButton
              ref={ref}
              disabled={service.is_disable_click}
              isSaved={isLiked}
              onClick={() => {
                if (!service.is_login) {
                  service.goToLogin();
                  return;
                }

                service.likeProduct(isLiked);
              }}
            />
          )}
        </LikeObserver>
      )}
    </>
  );
}
